export const modulesData = (
  Object.values(
    import.meta.glob("../../modules/*/module.tsx", {
      import: "default",
      eager: true,
    }),
  ) as ModuleData[]
).sort((a, b) => a.priority - b.priority);
